import { DriftClient, ReferrerInfo } from '@drift-labs/sdk';
import BREAKPOINTS from 'src/constants/breakpoints';

export const getReferrerInfo = async (
	driftClient: DriftClient,
	referrerName: string
): Promise<ReferrerInfo | undefined> => {
	let referrerInfo: ReferrerInfo | undefined = undefined;

	if (!driftClient || !driftClient.isSubscribed) return undefined;

	if (referrerName) {
		try {
			const referrerNameAccount =
				await driftClient.fetchReferrerNameAccount(referrerName);

			if (referrerNameAccount) {
				referrerInfo = {
					referrer: referrerNameAccount.user,
					referrerStats: referrerNameAccount.userStats,
				};
			}
		} catch (err) {
			console.log(err);
			return undefined;
		}
	}

	return referrerInfo;
};

export const getStoredReferrerParam = (mobileOnly = false) => {
	if (typeof window === 'undefined') {
		return null;
	}

	const isMobile = window.innerWidth < BREAKPOINTS.SMALL;
	if (!isMobile && mobileOnly) {
		return null;
	}

	const storedReferrerParam = window.localStorage.getItem('referrerParam');
	const storedReferrerAppliedTimestamp = parseInt(
		window.localStorage.getItem('referrerAppliedTimestamp') ?? '0'
	);

	const isExpired =
		isNaN(storedReferrerAppliedTimestamp) ||
		Date.now() - storedReferrerAppliedTimestamp > 1000 * 60 * 60;

	if (!isExpired && storedReferrerParam) {
		return storedReferrerParam;
	} else {
		if (isExpired) {
			window.localStorage.removeItem('referrerParam');
			window.localStorage.removeItem('referrerAppliedTimestamp');
		}
		return null;
	}
};

export const getReferralLink = (accountDecodedName?: string) => {
	if (!accountDecodedName) return '';

	const referralLink = `app.drift.trade/ref/${accountDecodedName}`;
	return referralLink;
};
